var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorships(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.00006H18C18.9319 9.00006 19.3978 9.00006 19.7654 9.1523C20.2554 9.35529 20.6448 9.74464 20.8478 10.2347C21 10.6023 21 11.0682 21 12.0001C21 12.932 21 13.3979 20.8478 13.7655C20.6448 14.2555 20.2554 14.6449 19.7654 14.8479C19.3978 15.0001 18.9319 15.0001 18 15.0001H13",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.0001H3",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.0001H15C15.9319 15.0001 16.3978 15.0001 16.7654 15.1523C17.2554 15.3553 17.6448 15.7447 17.8478 16.2347C18 16.6023 18 17.0682 18 18.0001C18 18.932 18 19.3979 17.8478 19.7655C17.6448 20.2555 17.2554 20.6449 16.7654 20.8479C16.3978 21.0001 15.9319 21.0001 15 21.0001H3",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.00006H14C14.9319 3.00006 15.3978 3.00006 15.7654 3.1523C16.2554 3.35529 16.6448 3.74464 16.8478 4.23469C17 4.60224 17 5.06818 17 6.00006C17 6.93194 17 7.39788 16.8478 7.76543C16.6448 8.25548 16.2554 8.64483 15.7654 8.84782C15.3978 9.00006 14.9319 9.00006 14 9.00006H3",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.00006V15.1906C13 16.3046 13 16.8617 12.6735 16.9804C12.3469 17.0992 11.9782 16.6762 11.2407 15.8304L10.7593 15.2781C10.4064 14.8734 10.23 14.671 10 14.671C9.77003 14.671 9.5936 14.8734 9.24074 15.2781L8.75926 15.8304C8.02179 16.6762 7.65305 17.0992 7.32653 16.9804C7 16.8617 7 16.3046 7 15.1906V9.00006",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorships);
export default __webpack_public_path__ + "static/media/Mentorships.dd763f7f1e68c7ad30bdf206401e4d0c.svg";
export { ForwardRef as ReactComponent };